import type { RouteRecordRaw, Router } from 'vue-router'

const VoluntaryContractRoutes: RouteRecordRaw = {
  path: '/contract/nonFinancial/voluntary',
  name: 'VoluntaryModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'VoluntaryMainRoute',
      component: () => import('./views/VoluntaryView.vue'),
      meta: {
        title: 'voluntary.voluntaryContract',
      },
    },
    {
      path: 'create',
      name: 'VoluntaryCreateRoute',
      component: () => import('./views/VoluntaryUpsertView.vue'),
      meta: {
        title: 'voluntary.createVoluntaryContract',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:voluntaryId',
      name: 'VoluntaryEditRoute',
      component: () => import('./views/VoluntaryUpsertView.vue'),
      meta: {
        title: 'voluntary.editVoluntaryContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:voluntaryId',
      name: 'ViewVoluntaryRoute',
      component: () => import('./views/SingleVoluntaryView.vue'),
      meta: {
        title: 'voluntary.ViewVoluntary',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(VoluntaryContractRoutes)
}
